import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowTriangleTop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowTriangleTop"><Path d="M3.37988 19.9997H20.616L11.9979 2.76367L3.37988 19.9997Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowTriangleTop;
